import React, { useContext, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import CancelIcon from '@material-ui/icons/Cancel'
import RenderEmoji from './RenderEmoji'
import { SessionContext } from './session-context'
import { getItem, setItem } from './js/data-providers'


const useStyles = makeStyles(theme => ({
  cancelIcon: {
    backgroundColor: theme.palette.primary.main,
    height: 18,
    width: 18,
    color: 'white',
    borderRadius: '50%'
  }
}))

function MiniPrompt (props) {
  const { welcomePacket } = useContext(SessionContext)
  const classes = useStyles()
  const openChat = props.openChat
  const toggleOpenChat = props.toggleOpenChat
  const packet_code = props.packet_code
  const storage_miniPromptHasBeenDismissed = getItem(`mini-prompt-dismissed-${packet_code}`)
  const [miniPromptHasBeenDismissed, setMiniPromptHasBeenDismissed] = useState(storage_miniPromptHasBeenDismissed)
  const [displayPrompt, setDisplayPrompt] = useState(false)
  const setDisplayState = props.setDisplayState

  const events = props.events

  if (openChat || !welcomePacket) {
    return (
      <></>
    )
  }

  let promptText = ''

  let usingEventPrompt = false

  if (events) {
    const chatEvents = events.filter(item => {
      return item.attributes.kind === 'chat'
    })
    if (chatEvents.length) {
      promptText = chatEvents[0].attributes.body
      if (!displayPrompt) {
        setTimeout(() => setDisplayPrompt(true), 500)
      }
      usingEventPrompt = true
    }
  }

  if (!welcomePacket.online && !usingEventPrompt) {
    return (
      <></>
    )
  }

  if (!displayPrompt) {
    return (
      <></>
    )
  }

  function dismissMiniPrompt (e) {
    e.stopPropagation()
    setItem(`mini-prompt-dismissed-${packet_code}`, 'yes')
    setMiniPromptHasBeenDismissed(true)
    setDisplayState('icon')
  }

  return (
    <>
      {openChat || miniPromptHasBeenDismissed ? (
        <></>
      ) : (
        <div style={{ position: 'absolute', right: 20, bottom: 5, maxWidth: 260 }}>
          <div onClick={toggleOpenChat} className='mini-prompt'>
            <div className='mini-prompt-close' onClick={dismissMiniPrompt}>
              <CancelIcon
                className={classes.cancelIcon}
              />
            </div>
            <RenderEmoji
              text={promptText}
              rich='true'
            />
          </div>
        </div>
      )}
    </>
  )
}

export default MiniPrompt
